/* eslint-disable */
import React, { Component } from 'react';
import Text from '../Styled/Text';
import Headline from '../Styled/Headline';
import Closer from './Closer';

class FAQ extends Component {
  render() {
    return (
      <div>
        <Closer setInfoboxContent={this.props.setInfoboxContent} />
        <Headline>Was ist das monatliche Haushaltsnettoeinkommen?</Headline>
        <Text>
          Das monatliche Haushaltsnettoeinkommen umfasst die Bruttoeinkommen
          aller Haushaltsmitglieder abzüglich der Sozialversicherungsbeiträge
          und direkter Steuern wie der Einkommensteuer. Zum Einkommen zählen
          Löhne, Einkommen aus selbstständiger Arbeit, Zinsen, Mieteinnahmen,
          Renten und staatliche Transferleistungen wie beispielsweise
          Arbeitslosen- und Kindergeld. Zudem wird bei Eigentümerhaushalten der
          monatliche Nettomietwert des selbstgenutzten Wohneigentums als
          zusätzlicher Einkommensbestandteil berücksichtigt.
        </Text>
        <Headline>
          Was ist das „bedarfsgewichtete Haushaltsnettoeinkommen“?
        </Headline>
        <Text>
          Das bedarfsgewichtete Haushaltsnettoeinkommen (auch
          Nettoäquivalenzeinkommen) berücksichtigt, dass Kinder weniger Geld
          brauchen als Erwachsene, und dass das Leben in einigen Bereichen
          günstiger wird, wenn mehrere Menschen zusammenleben. Deshalb wird das
          gesamte monatliche Haushaltsnettoeinkommen (siehe vorherige Frage)
          durch die bedarfsgewichtete Zahl der Haushaltsmitglieder geteilt. Der
          erste Erwachsene hat den Faktor 1, jedes weitere Haushaltsmitglied
          über 14 Jahren den Faktor 0,5, Kinder unter 14 Jahren den Faktor 0,3.
          Ein Paar ohne Kinder muss demnach nur über das 1,5fache des Einkommens
          eines Singlehaushalts verfügen, um statistisch dasselbe Einkommen zu
          beziehen.
        </Text>
        <Headline>Was ist das Medianeinkommen?</Headline>
        <Text>
          Das Medianeinkommen (auch mittleres Einkommen) ist das Einkommen, das
          alle Einkommensbezieher in zwei gleich große Gruppen teilt: Die eine
          Hälfte hat höhere Einkommen, die andere niedrigere. Das
          Medianeinkommen ist verglichen mit dem Durchschnittseinkommen robuster
          gegenüber statistischen Ausreißern (stark vom Durchschnitt abweichende
          Werte).
        </Text>
        <Headline>Was zeigen die Kurven in der Grafik?</Headline>
        <Text>
          Die Kurven zeigen den geglätteten Verlauf der Einkommensverteilung.
          Grundlage sind die Bevölkerungsanteile für jeden 400-Euro-Abschnitt
          auf der vertikalen Skala für das bedarfsgewichtete
          Haushaltsnettoeinkommen. Wenn beispielsweise 15 Prozent der
          Bevölkerung zwischen 2.000 und 2.400 Euro verdienen, so wird die Kurve
          in diesem Abschnitt die 15 Prozent schneiden, in Teilen aber darüber
          und darunter verlaufen. Ähnlich wie bei der Schätzung einer
          Kerndichtefunktion wird die diskrete Verteilung der Einkommen mittels
          einer Kurve geglättet und in eine gleichmäßige, stetige Verteilung
          umgewandelt. Während sich die Anteile der Bevölkerung in den
          400-Euro-Einkommensbandbreiten einfach in Prozent ausdrücken lassen,
          steht bei der Dichtefunktion die Fläche unterhalb der Kurve im
          Vordergrund und gibt die Wahrscheinlichkeit an, mit der eine bestimmte
          Einkommenshöhe beobachtet wird. Die gesamte Fläche unter der Kurve
          repräsentiert immer 100 Prozent dieser Gruppe.
        </Text>
        <Headline>
          Warum werden die Flächen im oberen Einkommensbereich größer?
        </Headline>
        <Text>
          Die vertikale Skala verläuft in 400-Euro-Abschnitten von 0 bis 6.000
          Euro. Weil ab einer bestimmten Einkommenshöhe nur sehr wenige Menschen
          in einen 400-Euro-Abschnitt fallen, dafür aber einige Menschen sehr
          hohe Einkommen beziehen, sind die Euro-Abschnitte am oberen Ende der
          Skala größer. Die Einkommen zwischen 6.000 und 7.000 werden als
          einzelnes Einkommensintervall betrachtet und ebenso alle Einkommen
          größer als 7.000 Euro. Damit wird verhindert, dass die Einkommensskala
          sehr lang und die Grafik unübersichtlich wird. Allerdings schwillt die
          Kurve dadurch am oberen Ende an, was sie bei gleichbleibenden
          Einkommensschritten nicht tun würde.
        </Text>
        <Headline>
          Wie errechnet sich der Anteil der Ärmeren und Reicheren?
        </Headline>
        <Text>
          Zunächst wurden die bedarfsgewichteten Haushaltsnettoeinkommen in
          jeder Vergleichsgruppe aufsteigend sortiert und anschließend in 100
          gleich große Gruppen unterteilt (Perzentile). Für jedes Perzentil
          wurde das Medianeinkommen ermittelt. Das bedarfsgewichtete
          Haushaltsnettoeinkommen des Nutzers wird mit den berechneten
          Medianeinkommen der Perzentile verglichen. Die Perzentile mit höherem
          Medianeinkommen werden addiert zum Anteil der reicheren Personen, die
          Perzentile mit geringerem Medianeinkommen zum Anteil der ärmeren. Bei
          den Angaben „x Prozent sind reicher“ und „y Prozent sind ärmer“ sind
          jeweils gerundete Werte ausgewiesen. Für die Einkommensränder heißt
          das, wenn weniger als 0,5 Prozent der Bevölkerung über ein geringeres
          Einkommen verfügen, erfolgt die Einordnung in den Bereich „0 Prozent
          ärmer“, wenn weniger als 0,5 Prozent ein höheres Einkommen verfügen,
          sind gerundet „0 Prozent reicher“.
        </Text>
        <Headline>Auf welchen Daten basiert die Auswertung?</Headline>
        <Text>
          Die Berechnungen basieren auf Daten des Sozio-oekonomischen Panels
          (SOEP). Das SOEP ist eine seit 1984 durchgeführte repräsentative
          Wiederholungsbefragung in Deutschland von aktuell rund 35.000 Personen
          aus knapp 20.000 Haushalten. Aktuell sind die SOEP-Daten bis zum Jahr
          2020 verfügbar, wobei sich die Einkommen – entgegen der
          sozio-demografischen Merkmale – auf das jeweilige Vorjahr beziehen,
          also 2019. Da hier die Einkommensverteilung im Vordergrund steht,
          beziehen sich die Jahreszahlen in der Grafik also auf das Jahr 2019.
        </Text>
        <Headline>Wie setzt sich die Gruppe der Rentner zusammen?</Headline>
        <Text>
          Zu dieser Gruppe gehören alle Personen, die eine gesetzliche Rente
          beziehen und gleichzeitig älter als 60 Jahre sind. Die Rente kann
          durch Erwerbseinkommen ergänzt werden.
        </Text>
        <Headline>
          Wie setzen sich die Gruppen nach Heizungsart zusammen?
        </Headline>
        <Text>
          Im SOEP werden die Haushalte in mehrjährigen Abständen danach gefragt,
          welche Energiearten sie für die Heizung, für die Warmwasserbereitung,
          zum Kochen, für Licht und Haushaltsgeräte verwenden und welche
          Verbrauchskosten inklusive der Grundgebühren dafür anfallen. Da ein
          Haushalt unterschiedliche Energieträger gleichzeitig nutzen kann,
          werden die Haushalte zunächst den drei Hauptenergieträgern Gas, Heizöl
          und Fernwärme zugeordnet. Die übrigen Haushalte werden – gemäß den
          höchsten Ausgaben für den jeweiligen Energieträger – in den beiden
          Teilgruppen "Alternative" Energiequellen (Holz, Holzpellets, Erd- und
          andere Umweltwärme, Abluftwärme, Wärmepumpen, Biomasse und Solarwärme)
          und "Sonstige" Quellen (Strom, Kohle und Haushalte ohne Angabe zum
          Energieträger) einsortiert.
        </Text>
        <Headline>
          Wie setzen sich die Gruppen Vollzeit und Teilzeit zusammen?
        </Headline>
        <Text>
          Eine Vollzeittätigkeit entspricht einer durchschnittlichen
          Wochenarbeitszeit von mindestens 35 Stunden. Als
          Teilzeiterwerbstätiger gilt in dieser Betrachtung, wer regelmäßig mehr
          als 1 und weniger als 35 Wochenarbeitsstunden leistet.
        </Text>
        <Headline>Wie setzen sich die Gruppen West und Ost zusammen?</Headline>
        <Text>
          Zur Vergleichsgruppe Ost gehören alle Personen mit Wohnsitz in einem
          der ostdeutschen Bundesländer inklusive Berlin. Zur Vergleichsgruppe
          West gehören entsprechend alle anderen. Regionale Preisunterschiede
          werden bei der Betrachtung nicht berücksichtigt. Kaufkraftvergleiche
          würden zwischen West und Ost geringere Unterschiede hervorbringen.
        </Text>
        <Headline>Wie setzt sich die Gruppe Wohnort zusammen?</Headline>
        <Text>
          Zur Vergleichsgruppe 500.000 und mehr gehören alle Personen, die in
          einer Stadt mit mindestens 500.000 Einwohnern leben. Je nach
          Einwohnergröße des jeweiligen Wohnortes sortieren sich die übrigen
          Personen entsprechend in die weiteren Kategorien ein. Bei
          Berücksichtigung regionaler Preise würde die Kaufkraft der Einkommen
          insbesondere in Großstädten geringer ausfallen.
        </Text>
        <Headline>Wie setzt sich die Gruppe ohne Ausbildung zusammen?</Headline>
        <Text>
          Zu dieser Gruppe gehören Personen mit maximal mittlerem Schulabschluss
          und ohne Berufsausbildung. Dazu zählen Personen mit
          Hauptschulabschluss ohne berufliche Ausbildung, mit mittlerer Reife
          ohne berufliche Ausbildung sowie Personen, die weder über einen
          allgemeinbildenden noch über einen beruflichen Abschluss verfügen.
          Personen mit Hochschulzugangsberechtigung gehören nicht zu dieser
          Gruppe, unabhängig davon, ob sie eine berufliche Ausbildung absolviert
          haben oder nicht.
        </Text>
        <Headline>Wie setzt sich die Gruppe mit Studium zusammen?</Headline>
        <Text>
          Zu dieser Gruppe gehören alle Personen mit abgeschlossenem Studium an
          einer Fachhochschule oder Universität.
        </Text>
        <Headline>
          Wie setzt sich die Gruppe mit Wohneigentum zusammen?
        </Headline>
        <Text>
          Zu dieser Gruppe gehören alle Personen, die in einem Haushalt mit
          einem Immobilienbesitzer zusammenleben oder selbst einer sind. Im Fall
          selbstgenutzter Wohnimmobilien werden die um Hypotheken- und
          Instandhaltungskosten geminderten gesparten Mietausgaben als fiktives
          Einkommen zum sonstigen Einkommen addiert. Auch deshalb ist diese
          Bevölkerungsgruppe im Durchschnitt wohlhabender als der
          Bevölkerungsdurchschnitt.
        </Text>
        <Headline>
          Wie setzt sich die Gruppe der Zugewanderten zusammen?
        </Headline>
        <Text>
          Zu den Menschen mit Migrationshintergrund zählen alle nach 1949 auf
          das heutige Gebiet der Bundesrepublik Deutschland Zugewanderten
          (Vergleichsgruppe: selbst zugewandert), sowie alle in Deutschland
          Geborenen mit mindestens einem zugewanderten oder als Ausländer in
          Deutschland geborenen Elternteil (Vergleichsgruppe: Eltern
          zugewandert).
        </Text>
        <Headline>
          Welche Vergleichsgruppen haben den größten Anteil im mittleren
          Einkommensbereich?
        </Headline>
        <Text>
          Ein großer Anteil der Paarhaushalte mit Kindern hat ein Einkommen in
          der Nähe des Medianeinkommens der Gesamtbevölkerung. Ähnlich verteilt
          sind die Einkommen der Personen mittleren Alters (25 bis 49 Jahre) und
          mit mittlerem Bildungsniveau (mittlere Reife und Ausbildung).
        </Text>
        <Headline>
          Welche Vergleichsgruppen haben den größten Anteil im unteren
          Einkommensbereich?
        </Headline>
        <Text>
          Ein verhältnismäßig großer Anteil der Alleinerziehenden hat ein
          Einkommen unterhalb des Medianeinkommens der Gesamtbevölkerung. Viele
          Personen dieser Gruppe gehören zur armutsgefährdeten Bevölkerung
          (weniger als 60 Prozent des Medianeinkommens). Ähnlich verteilt sind
          die Einkommen der Personen mit Migrationshintergrund (selbst
          zugewandert und Eltern zugewandert) und ohne Ausbildung. Bei den
          Älteren (65 Jahre und älter) zeigt sich entgegen einer verbreiteten
          Wahrnehmung kein überdurchschnittliches Armutsrisiko.
        </Text>
        <Headline>
          Welche Vergleichsgruppen haben den größten Anteil im oberen
          Einkommensbereich?
        </Headline>
        <Text>
          Ein großer Anteil der Personen mit Hochschulabschluss hat ein
          Einkommen oberhalb des Medianeinkommens der Gesamtbevölkerung. Ähnlich
          verteilt sind die Einkommen der Personen mit Vollzeitbeschäftigung,
          mit Wohneigentum und von Paaren ohne Kinder. In dieser
          Vergleichsgruppe werden häufig zwei Einkommen erzielt und gleichzeitig
          aufgrund von Einspareffekten gemeinsamen Wirtschaftens pro Person
          weniger Einkommen benötigt als im Fall eines Alleinlebenden.
        </Text>
      </div>
    );
  }
}

export default FAQ;
